import getParamFromUrl from './getParamFromUrl'

/** 外部系统跳转登录携带的from字段枚举值 */
export enum TOKEN_FROM {
  LEYOKEY = 'leyokey',
  SRM = 'srm'
}

/** 外部系统跳转登录携带的from值 */
let tokenFrom = TOKEN_FROM.SRM
export function getTokenFrom() {
  return tokenFrom
}

export function setTokenFrom(value: TOKEN_FROM | string) {
  if (value === TOKEN_FROM.SRM || value === TOKEN_FROM.LEYOKEY) {
    tokenFrom = value
    return true
  }
  return false
}

const LEYOKEY_DOMAIN = import.meta.env.VITE_LEYOKEY_DOMAIN || 'https://auth.leyopharm.com/#/'
export const SRM_DOMAIN = import.meta.env.VITE_SRM_DOMAIN || 'https://gys.leyopharm.com/'

/**
 * @description 跳转到外部登录系统
 *
 * @export
 * @param {{ redirectPath?: string; delay?: number; fullPath?: boolean }} [config={
 *     redirectPath: '',
 *     delay: 1000,
 *     fullPath: false, // 重定向是否拼接完整路径 window.location.href
 *     mobile: false // 重定向是否指向 srm/mobile
 *   }]
 */
export function toOuterLogin(
  config: { redirectPath?: string; delay?: number; fullPath?: boolean; mobile?: boolean } = {
    redirectPath: '',
    delay: 1000,
    fullPath: false,
    mobile: false
  }
) {
  const from = tokenFrom
  let origin = SRM_DOMAIN
  if (from === TOKEN_FROM.LEYOKEY) {
    origin = LEYOKEY_DOMAIN
  } else if (config?.mobile) {
    origin += 'mobile/'
  }
  const { fullPath = false, delay = 1000 } = config
  let { redirectPath } = config
  let finalHref = origin
  if (fullPath) {
    redirectPath = window.location.href
  }
  if (redirectPath) {
    redirectPath = encodeURIComponent(window.btoa(redirectPath))
    finalHref += `?redirect=${redirectPath}&strict=1`
  }
  const codeParam = getParamFromUrl('code')
  setTimeout(() => {
    window.location.href = codeParam
      ? finalHref + `${redirectPath ? '&' : '?'}code=${codeParam}`
      : finalHref
  }, delay)
}

/**
 * 获取当前页面路径
 * @returns 当前路径
 */
export function getCurrentPath() {
  const { origin, pathname } = window.location
  return origin + pathname
}

/** 来源是否为 leyokey备用域名 */
export const isReferrerFromAuthBackup = () => {
  const backupUrls = [
    'auth8.leyopharm.com',
    'gys8.leyopharm.com'
  ]
  return backupUrls.some(url => {
    return (document?.referrer || '').indexOf(url) !== -1
  })
}
